import { useQuery } from 'react-query';
import { CACHE_TIME, STALE_TIME } from '@jwp/ott-common/src/constants';
import type { TInsights } from '@jwp/ott-common/types/insights';

import { $sanityFetch } from './utils/sanityCdnFetch';

export const sanityInsightsService = () =>
  $sanityFetch<TInsights>(`
*[_type == "insights"]{
  title,
  "slug": slug.current,
  category->{
    _id,
    title
  },
  thumbnail,
  thumbnailSource,
  publishDate,
  author{
    name,
    link
  },
  tags[]{
    tag,
    link
  },
  content
} | order(publishDate desc)
`);

export const useSanityInsights = () => {
  return useQuery(['sanityInsights'], sanityInsightsService, {
    staleTime: STALE_TIME,
    cacheTime: CACHE_TIME,
  });
};
